import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

export enum PrimeNgSeverity {
  success = 'success',
  info = 'info',
  warn = 'warn',
  error = 'error'
}

export enum PrimeNgToastPositionKey {
  TopCenter = 'top-center',
  TopRight = 'top-right',
  TopLeft = 'top-left'
}

export const defaultMessage: ToastMessageOptions = {
  key: PrimeNgToastPositionKey.TopCenter,
  life: 3000,
  closable: false
};

export const defaultSuccessMessage: ToastMessageOptions = {
  ...defaultMessage,
  icon: 'ei ei-16 ei-checkmark-circle green'
};

export const defaultInfoMessage: ToastMessageOptions = {
  ...defaultMessage
};

export const defaultWarnMessage: ToastMessageOptions = {
  ...defaultMessage
};

export const defaultErrorMessage: ToastMessageOptions = {
  ...defaultMessage,
  icon: 'ei ei-cross-circle red'
};

@Injectable({ providedIn: 'root' })
export class EfMessageService {
  constructor(private readonly messageService: MessageService) {}

  public success(message: ToastMessageOptions, useTranslation = true): void {
    const successMessage: ToastMessageOptions = { ...defaultSuccessMessage, ...message };
    this.add(PrimeNgSeverity.success, successMessage, useTranslation);
  }

  public info(message: ToastMessageOptions, useTranslation = true): void {
    const infoMessage: ToastMessageOptions = { ...defaultInfoMessage, ...message };
    this.add(PrimeNgSeverity.info, infoMessage, useTranslation);
  }

  public warn(message: ToastMessageOptions, useTranslation = true): void {
    const warnMessage: ToastMessageOptions = { ...defaultWarnMessage, ...message };
    this.add(PrimeNgSeverity.warn, warnMessage, useTranslation);
  }

  public error(message: ToastMessageOptions, useTranslation = true): void {
    const errorMessage: ToastMessageOptions = { ...defaultErrorMessage, ...message };
    this.add(PrimeNgSeverity.error, errorMessage, useTranslation);
  }

  private add(severity: PrimeNgSeverity, message: ToastMessageOptions, _useTranslation: boolean): void {
    this.messageService.add({
      ...message,
      severity: severity,
      summary: message.summary,
      key: 'notification',
      detail: message.detail,
      icon: message.icon,
      closable: false
    });
  }
}
